import { css, Theme } from '@emotion/react'

export const avatar = css`
  width: 28px;
  height: 28px;
  border-radius: 50%;

  [data-notfound='true'] {
    font-size: 0;
    color: transparent;
  }
`

export const index = (theme: Theme) => css`
  display: flex;
  width: 30px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 5px;
  border-radius: 38px;
  background: ${theme.backgrounds.backgroundFive};
  font-weight: 500;
  overflow-wrap: normal;
`

export const indexLabel = css`
  display: flex;
  width: 30px;
  justify-content: center;
`

export const button = css`
  margin: 24px auto 0;
`

export const longText = (theme: Theme) => css`
  max-height: 40px;
  width: 140px;
  overflow-y: scroll;
  color: ${theme.typographyColors.typographyTwo};
  font-weight: 500;

  &::-webkit-scrollbar {
    display: none;
  }
`

export const description = css`
  width: 270px;
`

export const editIcon = css`
  cursor: pointer;
`
